import React from "react";
import _ from "lodash";

import FluserUser from "../components/FluserUser";

import {exclamation} from "../../../assets/images/fluster";
import {question_mark} from "../../../assets/images/fluster";

const FlusterIntro = (props) => {
  const { parameters, answerer_player_details, asker_player_details } = props;
  const answerer_display_name = _.get(answerer_player_details, "display_name");
  const answerer_profile_image = _.get(answerer_player_details, "profile_image");
  const asker_display_name = _.get(asker_player_details, "display_name");
  const asker_profile_image = _.get(asker_player_details, "profile_image");
  const fluster_card = _.get(
    parameters,
    "5_flusterintro.fluster_card",
    "FLUSTER CARD"
  );
  const info_2 = _.get(parameters, "5_flusterintro.info_2", " Must Answer!");
  const info_1 = _.get(
    parameters,
    "5_flusterintro.info_1",
    " has played a Fluster Card! Now "
  );
  return (
    <div className="fluster-intro">
      <div className="top-content">
        <div className="left-content">
          <FluserUser 
          display_name = {asker_display_name} 
          profile_image = {asker_profile_image}  
          />
        </div>
        <div className="middle-content">
          <h1>{fluster_card}</h1>
          <img src={question_mark} alt="" />
        </div>
        <div className="right-content">
          <FluserUser 
          display_name = {answerer_display_name} 
          profile_image = {answerer_profile_image} 
          />
        </div>
      </div>
      <div className="bottom-content">
        <p>
          <span>{answerer_display_name}</span>
          {info_1} <span>{asker_display_name}</span> {info_2}
        </p>
      </div>
    </div>
  );
};

export default FlusterIntro;
